import { useState, useEffect } from 'react';
import './Style.css';
import api from '../../../services/api';
import { PgrFuncao } from '../Funcao';

export function PgrGhe({ idEmpresa, idFdt, idRevisao, selectedEmissaoId, documento, externoPgr, externoPcmso, enviado }: any) {

    const [ghes, setGhes]: any = useState([]);
    const [selectedGhe, setSelectedGhe]: any = useState(null);
    const [isInsertionMode, setIsInsertionMode] = useState(false); // State to manage insertion mode
    const [newGheNome, setNewGheNome]: any = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingGhe, setEditingGhe]: any = useState(null);
    const [manualInsertionMode, setManualInsertionMode] = useState(false);

    const handleGhesUpdateComplete = () => {
        fetchGhes()
    };

    const fetchGhes = async (id: any = null) => {
        try {
            const response = await api.post('listar-pgr', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_revisao: idRevisao
            });

            const ghesData = response.data.ghes || [];

            setGhes(ghesData);

            if (ghesData.length === 0) {
                setSelectedGhe(null);
            } else if (ghesData.length === 1) {
                setSelectedGhe(ghesData[0].id);
            } else if (ghesData.length > 1 && !ghesData.some((ghe: { id: any; }) => ghe.id === selectedGhe)) {
                setSelectedGhe(ghesData[0].id);
            }

        } catch (error) {
            console.error('There was a problem fetching GHE data:', error);
        }
    };

    const updateSelectAfterDeletion = () => {
        // Encontrar o elemento select pelo ID
        const selectElement = document.getElementById('ghes');
        if (!selectElement) {
            console.log("Select element not found");
            return;
        }

        // Encontrar a div que representa o option atualmente selecionado
        const selectedOptionDiv = selectElement.querySelector('.option-dsg.selected');
        if (!selectedOptionDiv) {
            console.log("Selected option not found");
            return;
        }

        // Obter os dados do option selecionado
        const selectedValue: any = selectedOptionDiv.getAttribute('data-value');
        const selectedName = selectedOptionDiv.textContent;

        // Encontrar a div que representa o primeiro option (placeholder)
        const firstOptionDiv = selectElement.querySelector('.option-dsg');
        if (!firstOptionDiv) {
            console.log("First option not found");
            return;
        }

        // Atualizar o texto e o valor do primeiro option (placeholder)
        firstOptionDiv.textContent = selectedName;
        firstOptionDiv.setAttribute('data-value', selectedValue);
    };



    useEffect(() => {
        fetchGhes(null);
    }, [idEmpresa, idFdt, idRevisao]);

    const handleSelectGhe = (id: any) => {
        setSelectedGhe(id);
        const gheSelecionado = ghes.find((ghe: any) => ghe.id === id);

        if (gheSelecionado) {
            setEditingGhe({ id: gheSelecionado.id, nome: gheSelecionado.nome });
        }
    };
    useEffect(() => {
        setIsInsertionMode(false);
        setManualInsertionMode(false);
    }, [idFdt]);
    // Para carregar os GHEs
    useEffect(() => {
        fetchGhes(null);
    }, [idEmpresa, idFdt, idRevisao]);

    // Para sair do modo de inserção quando idFdt mudar
    useEffect(() => {
        setIsInsertionMode(false);
        setManualInsertionMode(false);
    }, [idFdt]);


    const enterInsertionMode = () => {
        setIsInsertionMode(true);
        setManualInsertionMode(true); // Ativa o modo de inserção manual
    };

    const exitInsertionMode = () => {
        setIsInsertionMode(false);
        setManualInsertionMode(false); // Desativa o modo de inserção manual
    };

    const handleInsertGhe = async () => {
        try {
            const response = await api.post('inserir-ghe', {
                nome: newGheNome,
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_revisao: idRevisao,
            });

            setNewGheNome(''); // Reset o nome da nova GHE
            exitInsertionMode();
            fetchGhes(null);
        } catch (error) {
            console.error('Erro ao inserir GHE:', error);
        }
    };

    const enterEditMode = () => {
        const gheParaEditar = ghes.find((ghe: any) => ghe.id === selectedGhe);
        if (gheParaEditar) {
            setEditingGhe({ id: gheParaEditar.id, nome: gheParaEditar.nome });
        }
        setIsEditMode(true);
        setIsInsertionMode(false);
    };

    const exitEditMode = () => {
        setIsEditMode(false);
        setEditingGhe({ id: null, nome: '' });
    };

    const handleEditGhe = async () => {
        setSelectedGhe(null);
        try {
            await api.post('editar-ghe', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_ghe: editingGhe.id,
                nome: editingGhe.nome,
                // Outros dados necessários
            });
            const gheEditadoId = editingGhe.id; // Guarda o ID da GHE editada
            exitEditMode();
            await fetchGhes(gheEditadoId); // Atualiza a lista de GHEs

            // Redefine selectedGhe para o ID da GHE que foi editada
        } catch (error) {
            console.error('Erro ao editar GHE:', error);
        }
    };

    const handleDeleteConfirm = async (idGhe: number) => {

        try {
            await api.post('excluir-ghe', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_ghe: idGhe,
            });
        } catch (error) {
            console.log(error)
        }
        await fetchGhes(); // Atualiza a lista de GHEs

        updateSelectAfterDeletion()

        // Se a lista estiver vazia, resete os estados selecionados
        setSelectedGhe(null)
        setIsEditMode(false);
        setIsInsertionMode(false);


    };

    return (
        <>
            <div className='py-4'>
                {/* <CardContent>
                    <Subtitle text="GRUPO HOMOGÊNEO DE EXPOSIÇÃO" />
                    <Row className='my-4'>
                        <Col md={6}>
                            <FormGroup className='form-group-dsg'>
                                <Label title="GRUPO HOMOGÊNEO DE EXPOSIÇÃO (GHE) " htmlFor="ghe" />
                                {isInsertionMode ? (
                                    <input
                                        type="text"
                                        id="ghe"
                                        value={newGheNome}
                                        placeholder="Nome da nova GHE"
                                        style={{ width: '100%' }}
                                        onChange={(e) => setNewGheNome(e.target.value)}
                                    />
                                ) : (
                                    <>
                                        {isEditMode ? (
                                            <div>
                                                <input
                                                    type="text"
                                                    value={editingGhe.nome}
                                                    onChange={(e) => setEditingGhe({ ...editingGhe, nome: e.target.value })}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        ) : (
                                            <Select width="100%" id="ghes" onSelect={handleSelectGhe}>
                                                {ghes.map((ghe: any) => (
                                                    <Options key={ghe.id} value={ghe.id} name={ghe.nome} selected={ghe.id === selectedGhe} />
                                                ))}
                                            </Select>
                                        )}
                                    </>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            &nbsp;
                            <div className="d-grid d-sm-flex justify-content-lg-end justify-content-md-start crud-fdt">
                                {isInsertionMode ? (
                                    <>
                                        <Button className='btn-main' onClick={handleInsertGhe}>Inserir GHE</Button>
                                        {isInsertionMode && manualInsertionMode && (
                                            <Button variant='secondary' onClick={exitInsertionMode}>Cancelar</Button>
                                        )}

                                    </>
                                ) : (
                                    <>
                                        {ghes && isEditMode ? (
                                            <>
                                                <Button onClick={handleEditGhe}>Salvar Edição</Button>
                                                <Button variant='secondary' onClick={exitEditMode}>Cancelar</Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button className='btn-main' onClick={enterInsertionMode}>Nova GHE</Button>
                                                <Button variant='primary' onClick={enterEditMode}>Editar GHE&nbsp;<FillPen /></Button>
                                                <DeleteModal
                                                    endpoint='excluir-ghe'
                                                    onConfirm={() => handleDeleteConfirm(selectedGhe)}
                                                    requestBody={{ id_fdt: idFdt, id_empresa: idEmpresa, id_ghe: selectedGhe }}
                                                />
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </CardContent> */}
                {!isInsertionMode && !manualInsertionMode && selectedGhe && (
                    <PgrFuncao idEmpresa={idEmpresa} idFdt={idFdt} idRevisao={idRevisao} idGhe={selectedGhe} UpdateComplete={handleGhesUpdateComplete}  selectedEmissaoId={selectedEmissaoId} documento={documento} externoPgr={externoPgr} externoPcmso={externoPcmso} enviado={enviado}/>
                )}
                {manualInsertionMode && selectedGhe && (
                    <PgrFuncao idEmpresa={idEmpresa} idFdt={idFdt} idRevisao={idRevisao} idGhe={selectedGhe} UpdateComplete={handleGhesUpdateComplete} selectedEmissaoId={selectedEmissaoId} documento={documento}  externoPgr={externoPgr} externoPcmso={externoPcmso} enviado={enviado}/>
                )}
            </div>
        </>
    );
}